import { currencyDefaults } from './const/currencyDefaults';
/**
 * Formats a number as a GBP currency value.
 */

interface CurrencyOptions {
  currency?: string;
  notation?: 'standard' | 'compact' | 'scientific' | 'engineering';
  compactDisplay?: 'short' | 'long';
  stripZeros?: boolean;
}
export const currency = (
  val: number | undefined,
  options?: CurrencyOptions,
) => {
  if (val === undefined) {
    return '';
  }
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: options?.currency ?? currencyDefaults.code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    notation: options?.notation ?? 'standard',
    compactDisplay: options?.compactDisplay ?? 'short',
    unitDisplay: 'long',
  });

  try {
    const formatted = formatter.format(val);
    return options?.stripZeros === false
      ? formatted
      : formatted.replace(/\D00(?=\D*$)/, '');
  } catch {
    // If we can't format this, return an empty string
    return '';
  }
};
